module.exports = {
      id: "search-usage",
      viewBox: "0 0 38 38",
      url: "img/" + "sprite.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }